export default __webpack_public_path__ + "static/media/n.8e2a9306.jpg";